import "bootstrap/dist/css/bootstrap.min.css";
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import mdiVue from 'mdi-vue/v3';
import * as mdijs from '@mdi/js';
import './assets/css/style.css';
import './assets/css/spinner.css';
import './assets/css/fonts.css';
import './assets/css/media.css';

// Импортируем хранилище
import store from './store';

const app = createApp(App);

app.use(router);
app.use(mdiVue, { icons: mdijs });
app.use(store);

app.mount("#app");

import "bootstrap/dist/js/bootstrap.js";